import React, {CSSProperties, useEffect, useState} from "react";
import {IconButton, Typography, TextField} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {IssueOverrideTag} from "common/types/issue_override_tag";

interface EditableTagNameProps {
  tag: IssueOverrideTag;
  onEdit: (tagId: number, name: string) => Promise<void>;
}

const styles: Record<string, CSSProperties> = {
  tagNameContainer: {
    flex: "0 0 20rem",
    display: "flex",
    alignItems: "center",
    marginRight: 16,
    height: 40,
  },
  tagName: {
    flex: 1,
    lineHeight: "40px",
  },
  editButton: {
    padding: 8,
  },
};

const EditableTagName: React.FC<EditableTagNameProps> = ({tag, onEdit}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [displayName, setDisplayName] = useState(tag.name);

  useEffect(() => {
    setDisplayName(tag.name);
  }, [tag.name]);

  const handleEdit = (newValue: string) => {
    if (newValue !== tag.name && newValue !== "") {
      setDisplayName(newValue);

      onEdit(tag.id, newValue).catch(() => {
        setDisplayName(tag.name);
      });
    }
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div style={styles.tagNameContainer}>
        <TextField
          autoFocus
          defaultValue={displayName}
          onBlur={e => {
            handleEdit(e.target.value.trim());
          }}
          onKeyDown={e => {
            if (e.key === "Enter") {
              e.currentTarget.blur();
            } else if (e.key === "Escape") {
              setIsEditing(false);
              setDisplayName(tag.name);
            }
          }}
          size="small"
          fullWidth
        />
      </div>
    );
  }

  return (
    <div style={styles.tagNameContainer}>
      <Typography style={styles.tagName}>{displayName}</Typography>
      <IconButton
        size="small"
        aria-label="edit"
        onClick={() => setIsEditing(true)}
        style={styles.editButton}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default EditableTagName;
